import Head from "@app/components/Head";
import JurysTable from "@app/components/PresidentJurysTable";
import JuryPresidentTabsSection from "@app/components/UserTabs/JuryPresidentTabsSection";

export default function PresidentJurysPage() {
  return (
    <>
      <Head options={{ title: "Liste des jurys" }} />
      <JuryPresidentTabsSection />
      <JurysTable />
    </>
  );
}
